import { render, staticRenderFns } from "./TicketActivityCard.vue?vue&type=template&id=54122596&scoped=true"
import script from "./TicketActivityCard.vue?vue&type=script&lang=js"
export * from "./TicketActivityCard.vue?vue&type=script&lang=js"
import style0 from "./TicketActivityCard.vue?vue&type=style&index=0&id=54122596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54122596",
  null
  
)

export default component.exports